import { BACKEND_URL_PREFIX } from "../utils/const";
import {
  NETWORK_REQUEST_SENT,
  SCHEDULE_ON_DATE_FETCH_COMPLETED,
  SCHEDULE_FETCH_COMPLETED,
  EDUCATION_YEAR_FETCHED,
  EDUCATION_YEAR_FETCH_COMPLETED,
  SCHEDULE_FETCH_STARTED,
  SCHEDULE_ON_DATE_FETCH_STARTED,
  SPECIALTY_FETCHED,
  CURRICULUM_FETCHED,
  PLAN_FETCH_STARTED,
  PLAN_FETCH_COMPLETED,
  SET_EXTRACT_DATA,
  SCHEDULE_FETCH_FAILED,
  SET_TEACHER_SCHEDULE,
} from "./types";
import { buildDefaultHeaders } from "./helper";
import { checkAndUpdateToken } from "./auth";
import { createNotification } from "../components/notifications/notifications";
import { extractParse } from "../utils/extractParse";


const BACKEND_URL_PREFIX_MTO = []

export const setInitialScehedule = () => ({ type: SCHEDULE_FETCH_COMPLETED, schedule: null })

export const scheduleOnDate = (date) => async (dispatch, getState) => {
  // await dispatch(checkAndUpdateToken());
  // if (getState().auth.token) {
  dispatch({ type: SCHEDULE_ON_DATE_FETCH_STARTED });
  const response = await fetch(
    `${BACKEND_URL_PREFIX}/schedule/${getState().auth.mid}/${date}`,
    buildDefaultHeaders(getState)
  );

  dispatch({ type: NETWORK_REQUEST_SENT, response });

  if (response.ok) {
    const result = await response.json();
    dispatch({
      type: SCHEDULE_ON_DATE_FETCH_COMPLETED,
      schedule: result.schedule,
    });
  }
  // }
};

export const schedule = (facultyId, edyId, scyId, monthId, urlPrefixMTO) => async (
  dispatch,
  getState
) => {
  // await dispatch(checkAndUpdateToken());
  // if (getState().auth.token) {
  dispatch({ type: SCHEDULE_FETCH_STARTED });
  // try {
  const response = await fetch(
    urlPrefixMTO ?
      `${urlPrefixMTO}schedule/${facultyId}/${edyId}/${scyId}/${monthId}` :
      `${BACKEND_URL_PREFIX}/schedule/${facultyId}/${edyId}/${scyId}/${monthId}`,
    buildDefaultHeaders(getState)
  );

  dispatch({ type: NETWORK_REQUEST_SENT, response });

  if (response.ok) {
    const result = await response.json();
    dispatch({ type: SCHEDULE_FETCH_COMPLETED, schedule: result, edyId });
  }
  // } catch (ERR) {
  //   createNotification('error', 'Не удалось составить расписание')
  //   dispatch({ type: SCHEDULE_FETCH_FAILED })
  // }
  // }
};

export const educationYear = () => async (dispatch, getState) => {
  // await dispatch(checkAndUpdateToken());
  // if (getState().auth.token) {
  const response = await fetch(
    `${BACKEND_URL_PREFIX}/year/edy`,
    buildDefaultHeaders(getState)
  );

  dispatch({ type: NETWORK_REQUEST_SENT, response });

  if (response.ok) {
    const result = await response.json();
    dispatch({
      type: EDUCATION_YEAR_FETCH_COMPLETED,
      educationYear: result.educationYear,
    });
  }
  // }
};

export const getYears = () => async (dispatch, getState) => {
  // await dispatch(checkAndUpdateToken());
  // if (getState().auth.token) {
  const response = await fetch(
    `${BACKEND_URL_PREFIX}/year/sy`,
    buildDefaultHeaders(getState)
  );

  dispatch({ type: NETWORK_REQUEST_SENT, response });

  if (response.ok) {
    const data = await response.json();
    dispatch({ type: EDUCATION_YEAR_FETCHED, studyYear: data.studyYear });
  }
  // }
};

export const getSpecialty = () => async (dispatch, getState) => {
  // await dispatch(checkAndUpdateToken());
  // if (getState().auth.token) {
  const response = await fetch(
    `${BACKEND_URL_PREFIX}/specialty/`,
    buildDefaultHeaders(getState)
  );

  dispatch({ type: NETWORK_REQUEST_SENT, response });

  if (response.ok) {
    const data = await response.json();

    dispatch({ type: SPECIALTY_FETCHED, militaryProfession: data.militaryProfession });
  }
  // }
};

export const getCurriculum = (yearId, specId) => async (dispatch, getState) => {
  // await dispatch(checkAndUpdateToken());
  // if (getState().auth.token) {
  const response = await fetch(
    `${BACKEND_URL_PREFIX}/curriculum/${yearId}/${specId}`,
    buildDefaultHeaders(getState)
  );

  dispatch({ type: NETWORK_REQUEST_SENT, response });

  if (response.ok) {
    const data = await response.json();
    dispatch({ type: CURRICULUM_FETCHED, curriculum: data });
  }
  // }
};

export const getPlan = (planId) => async (dispatch, getState) => {
  // await dispatch(checkAndUpdateToken());
  // if (getState().auth.token) {
  const response = await fetch(
    `${BACKEND_URL_PREFIX}/curriculum/${planId}`,
    buildDefaultHeaders(getState)
  );

  dispatch({ type: PLAN_FETCH_STARTED });
  dispatch({ type: NETWORK_REQUEST_SENT, response });

  if (response.ok) {
    const data = await response.json();
    dispatch({ type: PLAN_FETCH_COMPLETED, plan: data });
  }
  // }
};

export const getTeacherSchedule = (params) => async (dispatch, getState) => {
  // await dispatch(checkAndUpdateToken());
  // if (getState().auth.token) {
  const stringParams = new URLSearchParams(params).toString();
  const response = await fetch(
    `${BACKEND_URL_PREFIX}/schedule/vypiska?${stringParams}`,
    buildDefaultHeaders(getState)
  );
  if (response.ok) {
    const { schedule_data, schedule_data_info } = await response.json();
    const tableData = extractParse(schedule_data)
    const payload = { ...tableData, schedule_data_info }
    dispatch({ type: SET_TEACHER_SCHEDULE, payload });
  }
  // }
};
